// CSV export helpers — Turkish-friendly UTF-8 BOM
function csvEscape(v) {
  if (v === null || v === undefined) return '';
  const s = typeof v === 'string' ? v : (typeof v === 'object' ? JSON.stringify(v) : String(v));
  if (/[",\n;\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

export function rowsToCsv(rows, columns) {
  // columns: [{ key: 'col_path', label: 'Header' }]
  const header = columns.map(c => csvEscape(c.label)).join(';');
  const body = rows.map(r => columns.map(c => csvEscape(getPath(r, c.key))).join(';')).join('\n');
  return '\uFEFF' + header + '\n' + body;
}

function getPath(obj, path) {
  return path.split('.').reduce((acc, k) => (acc == null ? null : acc[k]), obj);
}

export function downloadCsv(filename, csv) {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function exportRows(filename, rows, columns) {
  downloadCsv(filename, rowsToCsv(rows, columns));
}
